import { Modal } from "react-bootstrap";
import ProductComboListModalProduct from "./ProductComboListModalProduct";

export default function ListModalBody(props) {
    
    const products = props.productComboChildDetails.productList.productComboProductList.map(item => {
        return (
            <ProductComboListModalProduct
                key={item.productId}
                data={item}
                handleSelectProductInComboList={props.handleSelectProductInComboList}
            />
        )
    });
    
    return (
        <Modal.Body className="pt-0">
            <div className="row">
                {products}
            </div>
        </Modal.Body>
    )
}